import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

const SaveIconButton = props => (
	<Button bsStyle='success' bsSize='xsmall' {...props}>
		<Glyphicon glyph='ok' />
	</Button>
);

export default SaveIconButton;